import { render, staticRenderFns } from "./DefaultOrganization.vue?vue&type=template&id=4568b23c&scoped=true&"
import script from "./DefaultOrganization.vue?vue&type=script&lang=js&"
export * from "./DefaultOrganization.vue?vue&type=script&lang=js&"
import style0 from "./DefaultOrganization.vue?vue&type=style&index=0&id=4568b23c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4568b23c",
  null
  
)

export default component.exports